// Smooth ease-in-out, used by animations that need it.
function easeInOut(t) {
  return (1 - Math.cos(Math.PI * t)) / 2;
}

// Each animation plugs into the grid via:
//   setup(square, cols, rows, cfg)      - called once per square, for randomized/static state
//   getOpacity(square, time, cols, rows, cfg) - called every frame, returns 0..1
const animations = {
  puzzle: {
    config: {
      minOpacity: 0.1,
      maxOpacity: 0.3,
      minDuration: 1,
      maxDuration: 4,
      speedCoefficient: 0.4,
      holdRatio: 0.5,
    },
    setup(square, cols, rows, cfg) {
      square.peakOpacity = cfg.minOpacity + Math.random() * (cfg.maxOpacity - cfg.minOpacity);
      square.duration = (cfg.minDuration + Math.random() * (cfg.maxDuration - cfg.minDuration)) / cfg.speedCoefficient;
      square.phaseOffset = Math.random() * square.duration;
    },
    getOpacity(square, time, cols, rows, cfg) {
      const t = (((time + square.phaseOffset) % square.duration) + square.duration) % square.duration / square.duration;
      const fadePercent = (1 - cfg.holdRatio) / 2;

      if (t < fadePercent) {
        return square.peakOpacity * (1 - easeInOut(t / fadePercent));
      }
      if (t < fadePercent + cfg.holdRatio) {
        return 0;
      }
      return square.peakOpacity * easeInOut((t - fadePercent - cfg.holdRatio) / fadePercent);
    },
  },

  horizontalWave: {
    config: {
      minOpacity: 0,
      maxOpacity: 0.5,
      waveSpeed: 20, // columns per second
      waveWidth: 200, // columns wide
    },
    setup() {},
    getOpacity(square, time, cols, rows, cfg) {
      const cyclePos = ((time * cfg.waveSpeed) % (cols + cfg.waveWidth)) - cfg.waveWidth;
      const distance = Math.abs(square.col - cyclePos);
      const intensity = Math.max(0, 1 - distance / (cfg.waveWidth / 2));
      return cfg.minOpacity + intensity * (cfg.maxOpacity - cfg.minOpacity);
    },
  },
};

export { animations };
